import { render, staticRenderFns } from "./ArtistBreadcrumbs.vue?vue&type=template&id=22166316&scoped=true&"
import script from "./ArtistBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ArtistBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22166316",
  null
  
)

export default component.exports